<div class="screen">
  <div class="container">
    <img src="assets/images/apyre_logo.svg" alt="logo" />
    <div class="actions">
      <p class="">Please sign in using your Apyre® email account.</p>
      <button (click)="login()" [disabled]="loading">
        {{ loading ? 'Signing in...' : 'Sign in with Google' }}
      </button>
    </div>
  </div>
</div>